import { Component } from 'preact'
import classNames from 'classnames'
import SingleItemList from './item-lists/SingleItemList'
import GroupedItemList from './item-lists/GroupedItemList'

class DropdownList extends Component {
  constructor (props) {
    super()
    this.state = {
      isOpen: true
    }
  }

  render (props, state) {
    const { isGrouped, type, align, items, displayListUpwards } = props
    const { isOpen } = state

    if (!isOpen) return

    const classes = classNames(
      'control-dropdown__list',
      type ? `control-dropdown__list--${type}` : null,
      `control-dropdown__list--${align}`,
      displayListUpwards ? `control-dropdown__list--up` : null
    )

    return (
      <div class={classes}>
        { items.map(item =>
          isGrouped
            ? <GroupedItemList groupName={item.groupName} items={item.items} onClick={() => this.setState({ isOpen: false })} />
            : <SingleItemList item={item} onClick={() => this.setState({ isOpen: false })} />
        )}
      </div>
    )
  }
}

export default DropdownList
